import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import Loading from "default/components/Loading";
import Error from "default/components/Error";
import TicketNotFound from "default/components/TicketNotFound";
import { useUrlParams } from "hooks/useUrlParams";
import useSystemQuestGroups from "hooks/useSystemQuestGroups";

import OmagunLayout from "../components/OmagunLayout";
import OmagunTitle from "../components/OmagunTitle";
import OmagunQuestCard from "../components/OmagunQuestCard";

const PAGE_CONFIG = {
  quests: { page: "Quests", title: "クエスト", variant: "quest" },
  trials: { page: "Trials", title: "試練", variant: "trial" },
  missions: { page: "Missions", title: <>グンマ<br />ミッション</>, variant: "mission" },
};

const withLanguage = (path, lng) => `${path}${path.includes("?") ? "&" : "?"}lng=${lng}`;

export default function QuestPage({ groupKey }) {
  const config = PAGE_CONFIG[groupKey];
  const navigate = useNavigate();
  const { soulId, lng, work } = useUrlParams();
  const { questGroups, hasPurchased, isLoading, isError } = useSystemQuestGroups(soulId);
  const group = questGroups.find((item) => item.quest_group_key === groupKey);

  if (isLoading) {
    return <OmagunLayout page={config.page}><Box sx={{ minHeight: "70vh", display: "grid", placeItems: "center" }}><Loading /></Box></OmagunLayout>;
  }
  if (isError) {
    return <OmagunLayout page={config.page}><Box sx={{ minHeight: "70vh", display: "grid", placeItems: "center" }}><Error /></Box></OmagunLayout>;
  }
  if (!hasPurchased) {
    return (
      <OmagunLayout page={config.page}>
        <Box sx={{ minHeight: "70vh", display: "grid", placeItems: "center", px: 3 }}>
          <TicketNotFound onClick={() => navigate(withLanguage(`/${work}/tickets?soul_id=${soulId}`, lng))} />
        </Box>
      </OmagunLayout>
    );
  }

  return (
    <OmagunLayout page={config.page}>
      <Box sx={{ px: groupKey === "trials" ? 2 : 3.5, pb: 4 }}>
        <OmagunTitle light={groupKey === "missions"}>{config.title}</OmagunTitle>
        {!group || group.quests.length === 0 ? (
          <Typography sx={{ textAlign: "center", py: 8, color: groupKey === "missions" ? "#4d0000" : "#fff" }}>
            表示できる項目がありません
          </Typography>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", gap: config.variant === "trial" ? 1 : 2.2 }}>
            {group.quests.map((quest, index) => (
              <OmagunQuestCard
                key={quest.quest_key}
                quest={quest}
                index={index}
                variant={config.variant}
              />
            ))}
          </Box>
        )}
      </Box>
    </OmagunLayout>
  );
}
